define(function() {
    var IpsModelCollection = require('civicsBase/ipsModelCollection');

    return IpsModelCollection.extend({
        urlRoot: '/delegate/civics-api/api/core/autocomplete/{0}/{1}?search={2}',
		url: function() {
			var url = this.urlRoot.format(this.moniker, this.property, encodeURI(this.term));
			//append any additional parameters that need to be passed to the server, if there are any.
			if (this.parameters) {
				//object.entries takes an object and returns an array of [key,value] arrays
				//reduce loops through an array and appends whats returned to the out variable then returns the final value
				url += Object.entries(this.parameters).reduce((out, current) => out + '&' + current[0] + '=' + current[1], '');
			}
			return url;
		},
        parse: function(response) {
			if (response.documents && response.documents.length >= 1) {
				// Check each documents and create a copy of property that has "."
				// e.g. "Address.StringRepresentation" => "Address_StringRepresentation"
				response.documents.forEach(doc => {
					if (doc.entries) {
						//sanitize response to prevent XSS. Probably overkill.
						Object.keys(doc.entries).forEach(entryProp => {
							if(typeof doc.entries[entryProp] === 'string'){
								doc.entries[entryProp] = Handlebars.helpers['global:sanitize'](doc.entries[entryProp]);
							  }
						});
						var entryPropWithPeriod = Object.keys(doc.entries).filter(prop => prop.includes('.'));
						entryPropWithPeriod.forEach(entryProp => {
							// make a copy of the entryProp with updated property name using "_"
							doc.entries[entryProp.replace(".", "_")] = doc.entries[entryProp];
						});

					}
				})
			}
            return response;
        }
    });
});
